import React, { useEffect } from "react";
import Select from "@components/elements/input/Select";
import { MinusCircleIcon, PlusCircleIcon } from "@heroicons/react/24/solid";
import Input from "@/components/elements/input/Input";

const types = [
  { name: "Twitter", value: "twitter", url: "https://twitter.com/" },
  { name: "Facebook", value: "facebook", url: "https://facebook.com/" },
  { name: "Instagram", value: "instagram", url: "https://instagram.com/" },
  { name: "Tiktok", value: "tiktok", url: "https://tiktok.com/" },
  { name: "Youtube", value: "youtube", url: "https://youtube.com/" },
  { name: "Linkedin", value: "linkedin", url: "https://linkedin.com/" },
  { name: "Xing", value: "xing", url: "https://xing.com/" },
];

type Social = {
  type: string;
  username: string;
};

type Props = {
  value: Array<Social>;
  onChange: (data: Array<Social>) => void;
};

const ProfileEditSocialsContainer = ({
  onChange,
  value = [{ type: "twitter", username: "" }],
}: Props) => {
  return (
    <div className="mt-1 col-span-2">
      {value.map((item, i: number) => (
        <div key={i} className="grid grid-cols-[1fr,auto] items-center gap-2">
          <div className="grid grid-cols-[100px,1fr] items-end gap-2">
            <Select
              items={types}
              name="type"
              onChange={(e) => {
                const newValue = value;
                newValue[i] = {
                  type: e.target.value,
                  username: item.username,
                };
                onChange(newValue);
              }}
              value={item.type}
              textSize="sm:text-xs"
            />

            <Input
              name="company-website"
              placeholder="username"
              value={item.username}
              onChange={(e) => {
                const newValue = value;
                newValue[i] = {
                  type: item.type,
                  username: e,
                };
                onChange(newValue);
              }}
            />
          </div>
          <button
            onClick={() => {
              const newValue = value;
              newValue.splice(i, 1);
              onChange(newValue);
            }}
            className="flex items-center pr-2 pt-2"
          >
            <MinusCircleIcon className="w-6 h-6 text-red-600" />
          </button>
        </div>
      ))}
      <button
        className="grid grid-cols-[auto,20px] items-center mt-2 w-full rounded-2xl border border-gray-300 shadow-sm py-1.5 px-3 hover:bg-zinc-100"
        onClick={() => {
          const newValue = value;
          newValue.push({ type: types[0].value, username: "" });
          onChange(newValue);
        }}
      >
        <div className="text-center text-sm">Neuen Link hinzufügen</div>
      </button>
    </div>
  );
};

export default ProfileEditSocialsContainer;
